import { styled } from '@mui/material/styles';
import { DEFAULT_SIDE_NAV_WIDTH } from '@aeg-presents/components/SideNav';

export const AppDiv = styled('main')({
  display: 'flex',
  minHeight: '100vh',
});

export const ContentStyled = styled('div')(({ theme }) => ({
  marginLeft: DEFAULT_SIDE_NAV_WIDTH,
  minWidth: `calc(100% - ${DEFAULT_SIDE_NAV_WIDTH})`,
  flex: 1,
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    minWidth: '100%',
  },
}));

export const MainContent = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(4, 6),
  width: '100%',
  fontFamily: 'Roboto, sans-serif',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(10, 2, 4),
  },
}));

export const LogoImage = styled('img')(({ theme }) => ({
  display: 'block',
  width: '33px',
  height: '45px',
  margin: '0 auto',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
